import React from 'react';
import { Link } from 'react-router-dom';
import PageMeta from './PageMeta';

const NotFound = () => (
  <div
    style={{
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '2rem',
      fontFamily: "'Montserrat', sans-serif",
    }}
  >
    <PageMeta
      title="Page Not Found (404) | Priyaa's Beauty Salon"
      description="Sorry, this page does not exist. Visit Priyaa's Beauty Salon, Perambur, Chennai for hair, bridal makeup, skin care and spa services."
      path="/404.html"
      noindex
    />
    <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '3rem', margin: 0 }}>
      404
    </h1>
    <p style={{ fontSize: '1.1rem', margin: '1rem 0 2rem' }}>
      Sorry, the page you are looking for does not exist.
    </p>
    <Link
      to="/"
      style={{
        background: '#d678d0',
        color: '#fff',
        padding: '0.75rem 1.75rem',
        borderRadius: '999px',
        textDecoration: 'none',
        fontWeight: 600,
      }}
    >
      Back to Home
    </Link>
  </div>
);

export default NotFound;
